/**
 * from https://www.npmjs.com/package/react-native-flash-message
 */
import FlashMessageManager from "./FlashMessageManager";
import FlashMessageWrapper, { getFlashMessageStatusBarHeight, styleWithInset } from "./FlashMessageWrapper";
import FlashMessage, {
  DefaultFlash,
  positionStyle,
  showMessage,
  hideMessage,
  FlashMessageTransition,
  renderFlashMessageIcon,
} from "./FlashMessage";

/**
 * 导出对象
 */
const YhwToastAPI = {
  FlashMessageManager,
  DefaultFlash,
  styleWithInset,
  getFlashMessageStatusBarHeight,
  positionStyle,
  showMessage,
  hideMessage,
  FlashMessageTransition,
  renderFlashMessageIcon,
};

export default YhwToastAPI
